module.exports = __webpack_public_path__ + "img/P150T_weapon_159.fa6e088c.png";